/**
 * Sanitize a value for safe interpolation inside a JavaScript string
 * literal within dangerouslySetInnerHTML. Uses a strict allowlist to
 * strip anything that could break out of the string context.
 */
export const sanitizeForScript = (value: string | null | undefined): string => {
  if (!value) return ""
  return value.replace(/[^a-zA-Z0-9_\-.:/= &?,@#%+()]/g, "")
}
